import reducers from "./reducers";

const eventsReducers = {
  events: reducers.eventsReducer,
  event: reducers.eventReducer,
  paidTickets: reducers.paidTicketsReducer
};

export { eventsReducers };
